import { SuccessorBorrowerLoans } from './SuccessorBorrowerLoans';

export default SuccessorBorrowerLoans;
